import React, { Component } from 'react'
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import ReactPlayer from 'react-player'

class GameCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoUrl: props.recapUrl,
            expanded: false,
            expandOnce: true
        }
    };

    changeVideo = (videoUrl) => {
        this.setState({
            videoUrl: videoUrl
        });
    }
    handleExpandChange = () => {
        this.setState({
            expanded: !this.state.expanded
        });
    }

    render() {
        return (
            <div className="GameCard">
                <Card className="Card"
                    expanded={this.state.expanded}
                    onExpandChange={this.handleExpandChange}>
                    <CardHeader
                        className="CardHeader"
                        title={
                            <div>
                                <div className="flex-item">{this.props.awayTeam.name} @ {this.props.homeTeam.name}</div>
                            </div>
                        }
                        subtitle={`${this.props.gameStart} - ${this.props.gameState}`}
                        subtitleColor="#f3f2f1"
                        subtitleStyle={{
                            fontSize: '13px',
                            paddingTop: '0.4em',
                            fontStyle: 'italic'
                        }}
                        actAsExpander={true}
                        showExpandableButton={true} />
                    <CardActions className="Grid"
                        actAsExpander={!this.state.expanded}
                    >
                        <FlatButton
                            className="Grid-cell"
                            label="Recap"
                            disabled={this.props.recapButtonDisabled}
                            onTouchTap={() => this.changeVideo(this.props.recapUrl)} />
                        <FlatButton
                            className="Grid-cell"
                            label="Extended"
                            disabled={this.props.extendedButtonDisabled}
                            onTouchTap={() => this.changeVideo(this.props.extendedUrl)} />
                    </CardActions>
                    <CardText expandable={true}>
                        <ReactPlayer
                            className="VideoPlayer"
                            width="100%"
                            height="auto"
                            controls
                            file={{ hlsOptions: { enableCEA708Captions: false } }}
                            url={this.state.videoUrl}
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}
export default GameCard;


// WEBPACK FOOTER //
// ./src/components/game_card.jsx